const formatRupee = (amount, options = {}) => {
  const { currency = "INR", decimals = 2, compact = true } = options;

  if (isNaN(amount)) return "Invalid amount";

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    notation: compact ? "compact" : "standard", // Adds compact formatting if enabled
  }).format(amount);
};

export default formatRupee;
